/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiReviewRequestEntityType {
    QUERY_TEMPLATE = 'QUERY_TEMPLATE',
    SCENARIO = 'SCENARIO',
    SCENARIO_VERSION = 'SCENARIO_VERSION',
    CUSTOM_LIST_RECORD = 'CUSTOM_LIST_RECORD'
}


export function instanceOfInternalApiReviewRequestEntityType(value: any): boolean {
    for (const key in InternalApiReviewRequestEntityType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiReviewRequestEntityType, key)) {
            if (InternalApiReviewRequestEntityType[key as keyof typeof InternalApiReviewRequestEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiReviewRequestEntityTypeFromJSON(json: any): InternalApiReviewRequestEntityType {
    return InternalApiReviewRequestEntityTypeFromJSONTyped(json, false);
}

export function InternalApiReviewRequestEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiReviewRequestEntityType {
    return json as InternalApiReviewRequestEntityType;
}

export function InternalApiReviewRequestEntityTypeToJSON(value?: InternalApiReviewRequestEntityType | null): any {
    return value as any;
}

export function InternalApiReviewRequestEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiReviewRequestEntityType {
    return value as InternalApiReviewRequestEntityType;
}

